import Badge from '../../ui/common/Badge';
import {ILabel} from '../type';

interface IProps {
  isBig?: boolean;
  label: ILabel;
}

export default function LabelBadgeV4({isBig, label}: IProps) {
  return (
    <Badge
      customStyle={{backgroundColor: label.bgColor}}
      label={label.text}
      className={cn('max-w-[168px] flex-center', {
        's11-bold-white h-18 px-5': isBig,
        's10-bold-white h-16 px-4': !isBig,
      })}
      isEllipsis={true}
    />
  );
}
